{
  "field": {
    "first": "First name",
    "middle_initial": "Middle initial (optional)",
    "nickname": "Nickname (optional)",
    "surname": "Surname",
    "suffix": "Suffix (optional)",
    "hint": "This is your golfer's name. It is not the name you sign in with."
  },
  "refused": {
    "first_required": "Your golfer needs a first name.",
    "first_too_long": "A first name can be up to 20 letters.",
    "surname_required": "Your golfer needs a surname.",
    "surname_too_long": "A surname can be up to 25 letters.",
    "initial_one_letter": "A middle initial is one letter.",
    "nickname_length": "A nickname is 2 to 16 letters.",
    "suffix_unknown": "Pick a suffix from the list, or leave it empty.",
    "digits": "Names use letters only, without numbers.",
    "characters": "Names use letters, spaces, hyphens and apostrophes only.",
    "full_stop": "A full stop goes only after the middle initial, and we add it for you.",
    "taken": "Another golfer already has this name. Try one of these:",
    "famous": "That name is too close to a well-known person. Try one of these:",
    "brand": "Names can't include a brand. Try one of these:",
    "offensive": "That name isn't allowed. Try another, or one of these:",
    "ai_refused": "That name isn't allowed. Try another, or one of these:",
    "real_name": "Keep your real name private: try a golfer name."
  },
  "warn_real_name": "This looks like your own name. Other players will see it. You can keep it, or pick a golfer name.",
  "suggestions_title": "Free suggestions, kept for you for 10 minutes",
  "view": {
    "name": "{name}",
    "being_checked": "{name} (Being checked)",
    "placeholder": "New golfer #{code}"
  },
  "being_checked_help": "We check every new name before other players see it. Until then they see a short placeholder. This usually takes less than a day.",
  "rename": {
    "free": "You can change the name for free in your golfer's first 7 days.",
    "paid": "Changing the name costs {coins, number} Coins. You can do it once in each half of a season.",
    "once_per_half": "You have changed the name once in this half of the season. You can change it again in the next half.",
    "old_name_held": "Your old name is kept for your golfer for 30 days."
  }
}
